export const leaveTypeConfigEnm = [
    { value: "leave", text: 'Leave' },
    { value: 'permission', text: 'Permission' },
    { value: 'work_from_home', text: 'Work From Home' },
];

export const selectPeriodEnm = [
    { value: 'full_day', text: 'Full Day' },
    { value: "first_half", text: 'First Half' },
    { value: 'second_half', text: 'Second Half' },
];

export const leavePolicyExpiryEnum = [
    { value: 1, text: '1 Month' },
    { value: 3, text: '3 Months' },
    { value: 6, text: '6 Months' },
    { value: 12, text: '12 Months' },
]

export const holidaytype = [
    { value: 'international', text: 'International' },
    { value: 'national', text: 'National' },
    { value: 'local', text: 'Local' },
    { value: 'others', text: 'Others' },
];

export const monthEnum = [
    { value: 0, text: 'All' },
    { value: 1, text: 'January' },
    { value: 2, text: 'February' },
    { value: 3, text: 'March' },
    { value: 4, text: 'April' },
    { value: 5, text: 'May' },
    { value: 6, text: 'June' },
    { value: 7, text: 'July' },
    { value: 8, text: 'August' },
    { value: 9, text: 'September' },
    { value: 10, text: 'October' },
    { value: 11, text: 'November' },
    { value: 12, text: 'December' },
];

export const attendanceStatus = [
    { value: "present", text: 'Present' },
    { value: 'absent', text: 'Absent' },
    { value: 'compensation', text: 'Compensation' },
    { value: 'on-duty', text: 'On-Duty' },
    { value: 'holiday', text: 'Holiday' },
    { value: 'week-off', text: 'Week Off' },
    { value: 'WFH', text: 'Work From Home' },
    { value: 'leave', text: 'Leave' },
]

export const statusEnum = [
    { value: "True", text: 'Active' },
    { value: "False", text: 'In Active' },
];

export const assetConditionEnum = [
    { value: "Good", text: 'Good' },
    { value: 'Bad', text: 'Bad' },
];

export const assetRegistryStatusEnum = [
    { value: "online", text: 'Online' },
    { value: 'offline', text: 'Offline' },
];